import { SUBTOPIC_WORKSPACE_MAP, WORKSPACE_VALUES } from "../config/ticketConfig";

/**
 * Resolves the Workspace JSON string from the selected topic and subtopic.
 * Mirrors backend EarningsWizardHelper.ResolveEarningsWorkspace.
 */
export function resolveEarningsWorkspace(selectedTopic: string, selectedSubtopic: string): string {
  const topicMap = SUBTOPIC_WORKSPACE_MAP[selectedTopic];
  if (!topicMap) return "";
  const displayName = topicMap[selectedSubtopic];
  if (!displayName) return "";
  return WORKSPACE_VALUES[displayName] ?? "";
}

/** Extracts the lowercase file extension from a filename. */
export function getFileExtension(name: string): string {
  return (name.split(".").pop() || "").toLowerCase();
}

/** Formats a byte count into a human-readable string (B / KB / MB). */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
